import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";

import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "react-select";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { Chip, Container, Typography } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import NumericInput from "react-numeric-input";

import PellEditor from "../../components/PellEditor";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import {
  StripedTableCell,
  StripedTableRow,
} from "../../components/StripedTable";
import Paper from "@mui/material/Paper";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import isEmpty from "lodash/isEmpty";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";

import { doService } from "../../services/ServiceHelper";
import {
  createActivity,
  updateActivity,
  getActivity,
  updateActivityLocations,
  getPresignedActivityFileUrl,
  saveActivityFile,
} from "../../services/ActivityService";
import { getLocations, getSchoolTeachers } from "../../services/SchoolService";
import { isStringEmpty, isUUID } from "../../services/StringService";
import {
  getTeacherUserLists,
  getSchoolStudents,
  getUserSummary,
  getUserPriority,
} from "../../services/UserService";
import ICONS_MOBILE from "../../data/icons-mobile.json";
import ICONS_DESKTOP from "../../data/icons-desktop.json";
import VideoAlert from "../../components/VideoAlert";
import InfoIcon from "../../components/InfoIcon";
import ImageSelectDialog from "../../components/ImageSelectDialog";
import ImagePreviewDialog from "../../components/ImagePreviewDialog";
import TableRowNoResults from "../../components/TableRowNoResults";
import { generateUUID, httpUpload } from "../../services/AbstractService";
import ProgressBar from "../../components/ProgressBar";
import { getSchoolStatus } from "../../services/SchoolService";

import {
  showErrorMulti,
  showToast,
  showOKCancelDialog,
} from "../../components/ATPDialogs";

const ManageActivity = () => {
  const location = useLocation();
  const { state } = location; // Destructure the state object

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();

  const [_pageTitle, setPageTitle] = useState("");
  const [_selectedIndex, setSelectedIndex] = React.useState(0);

  const [queryParams] = useSearchParams();
  const navigate = useNavigate();

  const INITIAL_LOCATION = {
    label: "-- SELECT LOCATION --",
    value: "XX",
  };
  const INITIAL_CATEGORY = {
    label: "-- SELECT CATEGORY --",
    value: "XX",
  };

  const OPTION_YES = { label: "YES", value: "Y" };
  const OPTION_NO = { label: "NO", value: "N" };

  const [_categories, setCategories] = useState([INITIAL_CATEGORY]);
  const [_locations, setLocations] = useState([INITIAL_LOCATION]);
  const [_userLists, setUserLists] = useState([]);
  const [_students, setStudents] = useState([]);
  const [_teachers, setTeachers] = useState([]);
  const [_tags, setTags] = useState([]);
  const [_openOptions] = useState([OPTION_YES, OPTION_NO]);

  const [_selectedLocation, setSelectedLocation] = useState(INITIAL_LOCATION);
  const [_isLocationChanged, setLocationChanged] = useState(false);

  const [_selectedCategory, setSelectedCategory] = useState(INITIAL_CATEGORY);
  const [_name, setName] = useState("");
  const [_description, setDescription] = useState("");
  const [_maxStudents, setMaxStudents] = useState(_school.defaultMaxAttendance);
  const [_icon, setIcon] = useState({ id: 2700 });

  const ALL_STUDENTS = { label: "-- ALL STUDENTS --", value: "A" };
  const SELECTED_STUDENTS = {
    label: "Selected Students (Specify Below)",
    value: "S",
  };

  const [_whoCanView] = useState([ALL_STUDENTS, SELECTED_STUDENTS]);
  const [_selectedWhoCanView, setSelectedWhoCanView] = useState(_whoCanView[0]);

  const [_selectedUserLists, setSelectedUserLists] = useState(null);

  const [_selectedStudents, setSelectedStudents] = useState(null);
  const [_selectedTeachers, setSelectedTeachers] = useState(null);
  const [_selectedTagEids, setSelectedTagEids] = useState(null);
  const [_meetingUrl, setMeetingUrl] = useState("");
  const [_meetingJoinCode, setMeetingJoinCode] = useState("");
  const [_markAllPresent, setMarkAllPresent] = useState(true);
  const [_privateActivity, setPrivateActivity] = useState(false);
  const [_privateChanged, setPrivateChanged] = useState(false);
  const [_actionLabel, setActionLabel] = useState("Create");

  const [_currentEid, setCurrentEid] = useState(null);
  const [_backDropOpen, setBackDropOpen] = useState(false);

  const [_iconDialogOpen, setIconDialogOpen] = useState(false);
  const [_imageLoaded, setImageLoaded] = useState(false);
  const [_selectedOpen, setSelectedOpen] = useState(OPTION_YES);

  const [_teacherEntry, setTeacherEntry] = useState({});
  const [_images, setImages] = useState([]);

  const { eid } = useParams();
  const [_imageOpenDialog, setImageOpenDialog] = useState(false);
  const [_previewImageOpen, setPreviewImageOpen] = useState(false);
  const [_previewImageSrc, setPreviewImageSrc] = useState("");
  const [_previewImageAlt, setPreviewImageAlt] = useState(
    "activity attachment",
  );
  const [_showProgress, setShowProgress] = useState(false);
  const [_hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [_schoolStatus, setSchoolStatus] = useState({});
  const handleClickSaveRef = useRef(null);
  const [_autoAdd, setAutoAdd] = useState(false);

  const ICON_WIDTH = 70;
  const ICON_HEIGHT = 70;

  useEffect(() => {
    const promises = [
      getSchoolStatus(_school, _jwt),
      getLocations(_school, _jwt),
      getTeacherUserLists(_school, _jwt),
      getSchoolStudents(_school, _jwt),
      getSchoolTeachers(_school, _jwt),
    ];

    if (!isStringEmpty(queryParams.get("name"))) {
      setName(queryParams.get("name"));
    }
    // same first item for mobile and desktop items
    loadSelectedIcon(ICONS_MOBILE[0][0]);

    setBackDropOpen(true);
    Promise.all(promises).then((results) => {
      const schoolStatus = results[0].data;
      const locations = loadLocations(results[1].data);
      const userLists = loadUserLists(results[2].data);

      setSchoolStatus(schoolStatus);

      // format them for the select component

      const students = loadStudents(results[3].data);
      const teachers = loadTeachers(results[4].data);

      const categories = loadCategories(schoolStatus.categories);
      const tags = loadTags(schoolStatus.tags);

      if (eid !== "create" && eid !== "admin-create") {
        loadExistingActivity(
          eid,
          categories,
          locations,
          students,
          teachers,
          tags,
          userLists,
        );
      }
      setBackDropOpen(false);
    });

    if (eid === "create") {
      setPageTitle("Create Activity");
      setCurrentEid(null);
      setActionLabel("Create");
    } else if (eid === "admin-create") {
      if (state && state.teacherEid) {
        getUserSummary(_school, _jwt, state.teacherEid).then((result) => {
          setTeacherEntry(result.data);
          setPageTitle(
            `Create Activity for ${result.data.first_name} ${result.data.last_name}`,
          );
          setCurrentEid(null);
          setActionLabel("Create");
        });
      }
    } else if (isUUID(eid)) {
      setPageTitle("Update Activity");
      setCurrentEid(eid);
      setActionLabel("Update");
    }

    setSelectedWhoCanView(_whoCanView[0]);
  }, []);

  const markUnsavedChanges = () => {
    setHasUnsavedChanges(true);
  };

  const loadExistingActivity = (
    eid,
    loadedCategories,
    loadedLocations,
    loadedStudents,
    loadedTeachers,
    loadedTags,
    loadedUserLists,
  ) => {
    doService(getActivity(_school, _jwt, eid), (results) => {
      const activity = results.data.activity;
      const students = results.data.students;
      const proctors = results.data.proctors;
      const files = results.data.files;
      const userLists = results.data.user_lists;
      const tags = results.data.tags;

      setName(activity.name);
      setDescription(activity.description);
      setMaxStudents(activity.maxAttendance);
      setMeetingUrl(activity.meetingUrl);
      setMeetingJoinCode(activity.meetingJoinCode);
      setAutoAdd(activity.autoAdd === "Y");

      setMarkAllPresent(activity.markAllPresent === "Y");
      setPrivateActivity(activity.isPrivate === "Y");

      // set proctors
      // set restricted students
      if (activity.restrictedEnrollment === "Y") {
        setSelectedWhoCanView(SELECTED_STUDENTS);
      } else {
        setSelectedWhoCanView(ALL_STUDENTS);
      }

      setSelectedUserLists(getSelectedElements(loadedUserLists, userLists));
      setSelectedStudents(getSelectedElements(loadedStudents, students));
      setSelectedTeachers(getSelectedElements(loadedTeachers, proctors));
      setSelectedTagEids(getSelectedElements(loadedTags, tags));

      setSelectedCategory(
        getSelectedElement(loadedCategories, activity.categoryEid),
      );
      setLocationChanged(false);

      setSelectedLocation(
        getSelectedElement(loadedLocations, activity.locationId),
      );

      if (activity.isOpen === "Y") {
        setSelectedOpen(OPTION_YES);
      } else {
        setSelectedOpen(OPTION_NO);
      }

      setImages(files);

      loadSelectedIcon(getIconById(activity.iconId));
    });
  };

  /**
   * generic search, does not matter if mobile or desktop; ID is same
   * @param {*} iconId
   * @returns
   */
  const getIconById = (iconId) => {
    for (let row of ICONS_MOBILE) {
      for (let image of row) {
        if (image.id === iconId) {
          return image;
        }
      }
    }
    return null;
  };

  /**
   * returns selected element from the <select> array list
   */
  const getSelectedElements = (list, valuesToFind) => {
    // map up to avoid cartesian product
    const map = {};
    for (let obj of list) {
      map[obj.value] = obj;
    }

    let selectedObjs = [];
    for (let value of valuesToFind) {
      if (map[value] != null) {
        selectedObjs.push(map[value]);
      }
    }

    return selectedObjs;
  };

  /**
   * returns selected element from the <select> array list
   */
  const getSelectedElement = (list, valueToFind) => {
    let selectedObj = null;
    for (let obj of list) {
      if (obj.value === valueToFind) {
        selectedObj = obj;
        break;
      }
    }
    return selectedObj;
  };

  const loadTeachers = (data) => {
    const labeledTeachers = [];
    const teacherMap = {};
    for (const teacher of data) {
      const entry = {
        label: `${teacher.last_name}, ${teacher.first_name}`,
        value: teacher.eid,
      };
      labeledTeachers.push(entry);
      teacherMap[teacher.eid] = entry;
    }
    setTeachers(labeledTeachers);
    return labeledTeachers;
  };

  const loadTags = (data) => {
    const labeled = [];
    // const teacherMap = {};
    for (const tag of data) {
      const entry = {
        label: `${tag.name}`,
        value: tag.eid,
      };
      labeled.push(entry);
      // teacherMap[teacher.eid] = entry;
    }
    // setTeacherMap(teacherMap);
    setTags(labeled);
    return labeled;
  };

  const loadStudents = (data) => {
    const labeledStudents = [];
    const studentMap = {};
    for (const student of data) {
      const entry = {
        label: `${student.last_name}, ${student.first_name} (${student.grade})`,
        value: student.eid,
      };
      labeledStudents.push(entry);
      studentMap[student.eid] = entry;
    }
    setStudents(labeledStudents);
    return labeledStudents;
  };

  const loadUserLists = (data) => {
    const entries = [];
    for (const entry of data) {
      entries.push({
        label: entry.name,
        value: entry.eid,
      });
    }
    setUserLists(entries);
    return entries;
  };

  const loadCategories = (data) => {
    const labeled = [INITIAL_CATEGORY];
    for (const obj of data) {
      labeled.push({
        label: obj.name,
        value: obj.eid,
      });
    }
    setCategories(labeled);
    return labeled;
  };

  const loadLocations = (data) => {
    const labeled = [INITIAL_LOCATION];
    for (const location of data) {
      labeled.push({
        label: location.name,
        value: location.id,
      });
    }
    setLocations(labeled);
    return labeled;
  };

  const validateActivity = () => {
    const title = `Unable to ${_actionLabel} Activity`;
    const messages = [];

    if (isStringEmpty(_name)) {
      messages.push("Please enter Activity Name.");
    }

    if (_selectedCategory.value === "XX") {
      messages.push("Please select an Activity Category.");
    }

    if (_selectedLocation.value === "XX") {
      messages.push("Please select a Location.");
    }

    let result = true;
    if (messages.length > 0) {
      result = false;
      showErrorMulti(title, messages);
    }

    return result;
  };

  const handleClickSave = () => {
    if (!validateActivity()) {
      return;
    }

    // if saving and students who can view is set to people then display warning
    // show warning if # of students 
    if (_autoAdd && _selectedWhoCanView.value === "S" && _selectedUserLists != null && _selectedUserLists.length > 0) { 
      if (
        !window.confirm(
          "WARNING: Auto Add is enabled and 1 or more student lists are selected.  All students in those will be automatically added to this activity starting today.  \n\nThis will add activities to their calendar for the rest of the year, except for those who have activities already created by other teachers.  Click OK to continue.",
        )
      ) {
        return;
      }
    }

    // if saving existing and private was changed and private is set to Y then
    if (_currentEid != null && _privateChanged && _privateActivity) {
      if (
        !window.confirm(
          "WARNING: You have set the activity to private.  All students will be notified that this activity is cancelled.  Click OK to continue.",
        )
      ) {
        return;
      }
    }
    doSaveActivity();
  };

  handleClickSaveRef.current = handleClickSave;

  const doSaveActivity = () => {
    const proctorEids = [];
    const studentEids = [];
    const userListEids = [];

    const tagEids = [];

    if (_selectedTeachers != null) {
      for (const proctor of _selectedTeachers) {
        proctorEids.push(proctor.value);
      }
    }

    if (_selectedStudents != null) {
      for (const student of _selectedStudents) {
        studentEids.push(student.value);
      }
    }

    if (_selectedTagEids != null) {
      for (const tag of _selectedTagEids) {
        tagEids.push(tag.value);
      }
    }

    if (_selectedUserLists != null) {
      for (const userList of _selectedUserLists) {
        userListEids.push(userList.value);
      }
    }

    const images = [];
    if (_images != null) {
      for (const image of _images) {
        images.push(image.eid);
      }
    }

    const values = {
      name: _name,
      description: _description,
      locationId: _selectedLocation.value,
      maxAttendance: _maxStudents,
      categoryEid: _selectedCategory.value,
      approvalNeeded: _school.activityApprovalEnabled,
      isPrivate: _privateActivity ? "Y" : "N",
      restrictedEnrollment: _selectedWhoCanView.value === "S" ? "Y" : "N",
      markAllPresent: _markAllPresent ? "Y" : "N",
      iconId: _icon.id,
      proctorEids: proctorEids,
      studentEids: studentEids,
      userListEids: userListEids,
      tagEids: tagEids,
      meetingUrl: _meetingUrl,
      meetingJoinCode: _meetingJoinCode,
      isOpen: _selectedOpen.value,
      files: images,
      autoAdd: _autoAdd ? "Y" : "N",
    };

    if (state && state.teacherEid) {
      values["createdForTeacherEid"] = state.teacherEid;
    }

    setBackDropOpen(true);
    if (_currentEid == null) {
      doService(
        createActivity(_school, _jwt, values),
        (results) => {
          setCurrentEid(results.data.eid);
          setActionLabel("Update");
        },
        null,
        null,
        () => {
          let message = "Activity Created. ";

          if (_school.approvalNeeded === "Y") {
            message +=
              "Your school admin team will approve this activity shortly.";
          }
          showToast("S", "Activity Created", message);
          setHasUnsavedChanges(false);
          setBackDropOpen(false);

          if (getUserPriority(_jwt) === 800 && state && state.teacherEid) {
            navigate("/adm/activity/teachers");
          } else {
            navigate("/teacher/activity/manage");
          }
        },
      );
    } else {
      doService(
        updateActivity(_school, _jwt, _currentEid, values),
        (results) => {},
        null,
        null,
        () => {
          showToast("S", "Activity Updated");
          setHasUnsavedChanges(false);

          if (_isLocationChanged) {
            showOKCancelDialog(
              "Activity Updated",
              "You have changed your default location.  Click OK to update all of your activity dates' locations.",
              () => {
                updateActivityLocations(_school, _jwt, _currentEid).then(() => {
                  showToast("S", "Locations Updated");
                });
                setLocationChanged(false);
              },
            );
          }
          setBackDropOpen(false);
        },
      );
    }
  };

  const handleChangeCategory = (obj) => {
    markUnsavedChanges();
    setSelectedCategory(obj);
  };
  const handleChangeLocation = (obj) => {
    markUnsavedChanges();
    setLocationChanged(true);
    setSelectedLocation(obj);
  };

  const handleChangeName = (event) => {
    markUnsavedChanges();
    setName(event.target.value);
  };

  const handleChangeDescription = (value) => {
    markUnsavedChanges();
    setDescription(value);
  };

  const handleChangeMaxStudents = (value) => {
    markUnsavedChanges();
    setMaxStudents(value);
  };
  const handleChangeWhoCanView = (obj) => {
    markUnsavedChanges();
    setSelectedWhoCanView(obj);
  };

  const handleChangeStudents = (objs) => {
    markUnsavedChanges();
    setSelectedStudents(objs);
  };

  const handleChangeUserLists = (objs) => {
    markUnsavedChanges();
    setSelectedUserLists(objs);
  };

  const handleChangeTeachers = (objs) => {
    markUnsavedChanges();
    setSelectedTeachers(objs);
  };
  const handleChangeTags = (objs) => {
    markUnsavedChanges();
    setSelectedTagEids(objs);
  };

  // const handleClickClearStudents = () => setSelectedStudents([]);

  const handleChangeMeetingJoinCode = (event) => {
    markUnsavedChanges();
    setMeetingJoinCode(event.target.value);
  };
  const handleChangeMeetingUrl = (event) => {
    markUnsavedChanges();
    setMeetingUrl(event.target.value);
  };
  const handleChangeMarkAllPresent = (event) => {
    markUnsavedChanges();
    setMarkAllPresent(event.target.checked);
  };
  const handleChangePrivateActivity = (event) => {
    markUnsavedChanges();
    setPrivateActivity(event.target.checked);
    setPrivateChanged(true);
  };

  const onTabChange = (event, index) => setSelectedIndex(index);

  const handleClickIconButton = () => {
    setIconDialogOpen(true);
  };

  const handleCloseIcon = () => {
    setIconDialogOpen(false);
  };

  const getSelectedIcon = (x, y) => {
    // console.log(x, y);

    let iconsArray = [];
    if (isMobile) {
      iconsArray = ICONS_MOBILE;
    } else {
      iconsArray = ICONS_DESKTOP;
    }

    for (let row of iconsArray) {
      for (let image of row) {
        // if within bounds then found
        const minIconX = image.x;
        const maxIconX = image.x + ICON_WIDTH;
        const minIconY = image.y;
        const maxIconY = image.y + ICON_HEIGHT;

        if (x >= minIconX && x < maxIconX && y >= minIconY && y < maxIconY) {
          return image;
        }
      }
    }

    return null;
  };

  const onIconSelect = (event) => {
    const icon = getSelectedIcon(
      event.nativeEvent.offsetX,
      event.nativeEvent.offsetY,
    );

    // don't set if whitespace clicked on
    if (icon == null) {
      return;
    }

    markUnsavedChanges();
    setIcon(icon);
    loadSelectedIcon(icon);
    setIconDialogOpen(false);
  };

  const loadSelectedIcon = (icon) => {
    if (document.getElementById("iconSelected")) {
      document.getElementById("iconSelected").src = "/image/icons/" + icon.path;
    }
  };

  // apply image to the canvas once loaded, one time, when image loaded
  // canvas to be used to pull a subset to display as selected item
  const onGridIconLoad = (event) => {
    const canvas = document.getElementById("iconCanvas");
    canvas.width = event.target.width;
    canvas.height = event.target.height;
    canvas.getContext("2d").drawImage(event.target, 0, 0);

    if (!_imageLoaded) {
      // set a little timeout before calling our cropping thing
      setTimeout(function () {
        // same first item, regardless if mobile or desktop
        setImageLoaded(true);
      }, 1000);
    }
  };

  const handleChangeOpen = (value) => {
    markUnsavedChanges();
    setSelectedOpen(value);
  };

  const handleCloseImageDialog = () => {
    setImageOpenDialog(false);
  };

  const handleOpenImagePreview = (image) => {
    const src =
      image.url ||
      image.imageUrl ||
      image.fullUrl ||
      image.originalUrl ||
      image.thumbnailUrl ||
      "";

    setPreviewImageSrc(src);
    setPreviewImageAlt(image.filename || "activity attachment");
    setPreviewImageOpen(true);
  };

  const handleCloseImagePreview = () => {
    setPreviewImageOpen(false);
    setPreviewImageSrc("");
  };

  // uploads the clipped image and the original
  const handleSelectImage = (image, thumbnailImage, fileObj, description) => {
    // on clicking the select button from the dialog
    const newFileUuid = generateUUID();

    setShowProgress(true);
    const promises = [
      uploadFile(newFileUuid, fileObj, fileObj, "original"),
      uploadFile(newFileUuid, image, fileObj, "scaled"),
      uploadFile(newFileUuid, thumbnailImage, fileObj, "thumbnail"),
    ];

    Promise.all(promises).then((results) => {
      return saveActivityFile(
        _school,
        _jwt,
        newFileUuid,
        fileObj.name,
        results[0].savedFilename,
        "",
        description,
        results[0].contentType,
        fileObj.size,
      ).then(() => {
        // show status;
        // update existing list
        const images = [..._images];
        images.push({
          eid: newFileUuid,
          filename: fileObj.name,
          saveFilename: results[0].savedFilename,
          thumbnailUrl: URL.createObjectURL(thumbnailImage),
          name: "",
          status: results[0].status,
          description: description,
        });
        setImages(images);
        markUnsavedChanges();

        setShowProgress(false);
        setImageOpenDialog(false);
      });
    });
  };

  const handlePageBack = () => {
    if (!_hasUnsavedChanges) {
      navigate(-1);
      return;
    }

    const shouldSave = window.confirm(
      "You have unsaved changes. Click OK to save now, or Cancel to leave without saving.",
    );

    if (shouldSave) {
      handleClickSave();
      return;
    }

    navigate(-1);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!_hasUnsavedChanges) {
        return;
      }

      event.preventDefault();
      event.returnValue = "";
    };

    const handlePopState = () => {
      if (!_hasUnsavedChanges) {
        return;
      }

      const shouldSave = window.confirm(
        "You have unsaved changes. Click OK to stay on this page and save. Click Cancel to leave without saving.",
      );

      if (shouldSave) {
        navigate(1);
        if (handleClickSaveRef.current) {
          handleClickSaveRef.current();
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [_hasUnsavedChanges, navigate]);

  const uploadFile = async (newFileUuid, image, fileObj, prefix) => {
    const result = await getPresignedActivityFileUrl(
      _school,
      _jwt,
      newFileUuid,
      prefix + "-" + fileObj.name,
    );

    const signedUrl = result.data.url;
    const contentType = result.data.content_type;
    const savedFilename = result.data.saved_filename;

    await httpUpload(signedUrl, image, contentType);

    return {
      signedUrl: signedUrl,
      contentType: contentType,
      savedFilename: savedFilename,
    };
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text={_pageTitle} showBack={true} onBack={handlePageBack} />

        <VideoAlert
          text="How to Create an Activity"
          url="https://canva.link/jxwyw1upfmz4x2n"
        />
        <ProgressBar showProgress={_showProgress} />

        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={8}>
            <Tabs value={_selectedIndex} onChange={onTabChange}>
              <Tab
                label="Details"
                sx={{
                  borderRight: "1px solid #ccc",
                  minHeight: 48,
                }}
              />
              <Tab
                label="Images"
                sx={{
                  borderRight: "1px solid #ccc",
                  minHeight: 48,
                }}
              />
              <Tab
                label="Access"
                sx={{
                  borderRight: "1px solid #ccc",
                  minHeight: 48,
                }}
              />
              <Tab
                label="Virtual"
                sx={{
                  borderRight: "1px solid #ccc",
                  minHeight: 48,
                }}
              />
              <Tab label="Extra" />
            </Tabs>
          </Grid>
          <Grid item xs={4}>
            <img
              id="iconSelected"
              width={64}
              height={64}
              className="pull-right"
              style={{ border: "2px dotted black", marginRight: "16px" }}
              onClick={handleClickIconButton}
            />
          </Grid>
        </Grid>

        {_selectedIndex === 0 && (
          <Container sx={{ pl: 0, border: "1px solid #e8e8e8" }}>
            <InputLabel sx={{ mt: 1 }}>Activity Category: *</InputLabel>
            <Select
              options={_categories}
              onChange={handleChangeCategory}
              value={_selectedCategory}
              disabled={
                _schoolStatus &&
                _schoolStatus.teacherEditEnabled === "N" &&
                getUserPriority(_jwt) < 800
              }
            />

            <InputLabel sx={{ mt: 1 }}>Activity Name: *</InputLabel>
            <TextField
              margin="dense"
              type="text"
              fullWidth
              size="small"
              onChange={handleChangeName}
              placeholder="Required Field"
              value={_name}
            />

            <InputLabel sx={{ mt: 1 }}>Location: *</InputLabel>
            <Select
              options={_locations}
              onChange={handleChangeLocation}
              value={_selectedLocation}
              disabled={
                _schoolStatus &&
                _schoolStatus.teacherEditEnabled === "N" &&
                getUserPriority(_jwt) < 800
              }
            />

            <InputLabel sx={{ mt: 1 }}>Max Students: *</InputLabel>
            <NumericInput
              className="numericInput"
              min={0}
              max={100}
              value={_maxStudents}
              onChange={handleChangeMaxStudents}
              disabled={
                _schoolStatus &&
                _schoolStatus.teacherEditEnabled === "N" &&
                getUserPriority(_jwt) < 800
              }
            />

            <InputLabel sx={{ mt: 1 }}>Tags:</InputLabel>
            <Select
              options={_tags}
              isMulti
              value={_selectedTagEids}
              onChange={handleChangeTags}
              disabled={
                _schoolStatus &&
                _schoolStatus.teacherEditEnabled === "N" &&
                getUserPriority(_jwt) < 800
              }
            />

            {_tags.length === 0 && (
              <Alert severity="info" sx={{ mt: 1 }}>
                NOTE: No tags are defined. Please contact your school
                administrator to create tags for your school.
              </Alert>
            )}

            <br />
            <Button onClick={handleClickSave} variant="contained">
              {_actionLabel} Activity
            </Button>
            <br />
            <br />
          </Container>
        )}

        {_selectedIndex === 1 && (
          <Container sx={{ pl: 0, border: "1px solid #e8e8e8" }}>
            <ImageSelectDialog
              open={_imageOpenDialog}
              onClose={handleCloseImageDialog}
              onSelect={handleSelectImage}
            />
            <ImagePreviewDialog
              open={_previewImageOpen}
              onClose={handleCloseImagePreview}
              src={_previewImageSrc}
              alt={_previewImageAlt}
            />
            <InputLabel sx={{ mt: 1 }}>Manage Images:</InputLabel>
            <Button
              variant="contained"
              sx={{ mt: 1 }}
              onClick={() => setImageOpenDialog(true)}
            >
              Add New Image
            </Button>
            <InputLabel sx={{ mt: 2 }}>Image List:</InputLabel>

            <TableContainer component={Paper} sx={{ mt: 1 }}>
              <Table size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell width="160">Image</StripedTableCell>
                    <StripedTableCell>Filename</StripedTableCell>
                    <StripedTableCell width="150" align="center">
                      Review Status
                    </StripedTableCell>
                    <StripedTableCell width="150" align="center">
                      Actions
                    </StripedTableCell>
                  </StripedTableRow>
                </TableHead>
                <TableBody>
                  <TableRowNoResults
                    data={_images}
                    text="-- NO IMAGES UPLOADED YET --"
                  />
                  {_images.map((image, index) => (
                    <StripedTableRow key={index}>
                      <StripedTableCell>
                        <img
                          src={image.thumbnailUrl}
                          alt={image.filename || "activity attachment"}
                          style={{
                            width: "160px",
                            height: "90px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpenImagePreview(image)}
                        />
                      </StripedTableCell>
                      <StripedTableCell>
                        {image.filename}
                        <br />
                        {!isEmpty(image.description) && (
                          <b>{image.description}</b>
                        )}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        {image.status === 0 && (
                          <Chip
                            label="Pending Review"
                            color="warning"
                            title="Pending review by admins"
                          />
                        )}
                        {image.status === 100 && (
                          <Chip
                            label="Approved"
                            color="success"
                            title="Approved by admins"
                          />
                        )}
                        {image.status === -100 && (
                          <Chip
                            label="Rejected"
                            color="error"
                            title="Rejected by admins"
                          />
                        )}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        <Button
                          variant="outlined"
                          size="small"
                          color="error"
                          sx={{ ml: 1 }}
                          onClick={() => {
                            const newImages = [..._images];
                            newImages.splice(index, 1);
                            setImages(newImages);
                            markUnsavedChanges();
                          }}
                        >
                          Remove
                        </Button>
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <Button onClick={handleClickSave} variant="contained">
              {_actionLabel} Activity
            </Button>
            <br />
            <br />
          </Container>
        )}

        {_selectedIndex === 2 && (
          <Container sx={{ pl: 0, border: "1px solid #e8e8e8" }}>
            <Alert severity="info" sx={{ mt: 1 }}>
              This identifies who can view and who can sign up for an activity.
              It DOES NOT automatically sign the students up for the activity.
              To add students to a date, please use Bulk Change page or the View
              Attendance page.
            </Alert>

            <InputLabel sx={{ mt: 1 }}>
              Students Who Can View Activity:
            </InputLabel>
            <Select
              options={_whoCanView}
              onChange={handleChangeWhoCanView}
              value={_selectedWhoCanView}
              disabled={
                _schoolStatus &&
                _schoolStatus.teacherEditEnabled === "N" &&
                getUserPriority(_jwt) < 800
              }
            />

            {_selectedWhoCanView.value === "S" && (
              <>
                <Alert severity="warning" sx={{ mt: 1 }}>
                  You can now select MULTIPLE LISTS. NOTE: they will not
                  populate the list of students below (and that's okay) - we're
                  just capturing the list names themselves.
                </Alert>

                <InputLabel sx={{ mt: 1 }}>
                  {" "}
                  Select from List (Optional):
                </InputLabel>
                <Select
                  options={_userLists}
                  isMulti
                  value={_selectedUserLists}
                  onChange={handleChangeUserLists}
                />

                <InputLabel sx={{ mt: 1 }}>
                  Enter Students (Optional):
                </InputLabel>
                <Select
                  options={_students}
                  isMulti
                  value={_selectedStudents}
                  onChange={handleChangeStudents}
                />

                <FormControlLabel
                  className="pull-right"
                  control={
                    <Switch
                      checked={_autoAdd}
                      onChange={(evt) => setAutoAdd(evt.target.checked)}
                      disabled={getUserPriority(_jwt) < 800}
                    />
                  }
                  label="Auto Add Students to Activity (only enabled for admins)"
                />
                <br />
              </>
            )}

            <Button
              onClick={handleClickSave}
              variant="contained"
              sx={{ mt: 1 }}
            >
              {_actionLabel} Activity
            </Button>
            <br />
            <br />
          </Container>
        )}

        {_selectedIndex === 3 && (
          <Container sx={{ pl: 0, border: "1px solid #e8e8e8" }}>
            <InputLabel sx={{ mt: 1 }}>Virtual Meeting URL:</InputLabel>
            <TextField
              margin="dense"
              type="text"
              fullWidth
              size="small"
              onChange={handleChangeMeetingUrl}
              placeholder="Optional Field"
              value={_meetingUrl}
            />
            <InputLabel sx={{ mt: 1 }}>Virtual Meeting Join Code:</InputLabel>
            <TextField
              margin="dense"
              type="text"
              fullWidth
              size="small"
              onChange={handleChangeMeetingJoinCode}
              placeholder="Optional Field"
              value={_meetingJoinCode}
            />
            <Button
              onClick={handleClickSave}
              variant="contained"
              sx={{ mt: 1 }}
            >
              {_actionLabel} Activity
            </Button>
            <br />
            <br />
          </Container>
        )}

        {_selectedIndex === 4 && (
          <Container sx={{ pl: 0, border: "1px solid #e8e8e8" }}>
            <InputLabel sx={{ mt: 1 }}>Activity Description:</InputLabel>
            <PellEditor
              value={_description}
              onChange={handleChangeDescription}
            />

            <InputLabel sx={{ mt: 1 }}>
              Proctors (they can also take attendance):
            </InputLabel>
            <Select
              options={_teachers}
              isMulti
              value={_selectedTeachers}
              onChange={handleChangeTeachers}
              disabled={
                _schoolStatus &&
                _schoolStatus.teacherEditEnabled === "N" &&
                getUserPriority(_jwt) < 800
              }
            />

            <InputLabel sx={{ mt: 2 }}>
              Is Open: *{" "}
              <InfoIcon text="This flag just indicates if the student needs to be specially invited to the activity.  To actually restrict students, click the Access tab above." />
            </InputLabel>
            <Select
              options={_openOptions}
              onChange={handleChangeOpen}
              value={_selectedOpen}
              disabled={
                _schoolStatus &&
                _schoolStatus.teacherEditEnabled === "N" &&
                getUserPriority(_jwt) < 800
              }
            />

            <br />

            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) => handleChangeMarkAllPresent(event)}
                  checked={_markAllPresent}
                  disabled={
                    _schoolStatus &&
                    _schoolStatus.teacherEditEnabled === "N" &&
                    getUserPriority(_jwt) < 800
                  }
                />
              }
              label={"Mark All Present"}
            />
            <Typography sx={{ ml: 2, mr: 2, color: "darkgray" }}>
              For Attendance, mark all students as present by default.
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) => handleChangePrivateActivity(event)}
                  checked={_privateActivity}
                  disabled={
                    _schoolStatus &&
                    _schoolStatus.teacherEditEnabled === "N" &&
                    getUserPriority(_jwt) < 800
                  }
                />
              }
              label={"Private Activity"}
            />
            <Typography sx={{ ml: 2, mr: 2, color: "darkgray" }}>
              Students cannot view this activity. Use if you will be unavailable
              on a specific date.
            </Typography>

            <Button
              onClick={handleClickSave}
              variant="contained"
              sx={{ mt: 1 }}
            >
              {_actionLabel} Activity
            </Button>
            <br />
            <br />
          </Container>
        )}

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={_backDropOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>

      <Dialog
        onClose={handleCloseIcon}
        open={_iconDialogOpen}
        fullScreen={true}
        PaperProps={{
          sx: {
            maxHeight: 600,
          },
        }}
      >
        <DialogTitle>Select Icon (scroll for more)</DialogTitle>

        <DialogContent sx={{ ml: 0, pl: 2, pr: 2 }}>
          {isMobile && (
            <img
              src="../../../image/icon-grid-mobile.png"
              alt="icons map"
              id="imgIcon"
              onMouseUp={onIconSelect}
              onLoad={onGridIconLoad}
              style={{ cursor: "pointer" }}
            />
          )}
          {!isMobile && (
            <img
              src="../../../image/icon-grid-desktop.png"
              alt="icons map"
              id="imgIcon"
              onMouseUp={onIconSelect}
              onLoad={onGridIconLoad}
              style={{ cursor: "pointer" }}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseIcon}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManageActivity;
